import { useEffect, useRef } from 'react';
/** A return destination only; the normal session and participant APIs still authorize it. */
export function usePeopleChatNavigation(authorizedSession:boolean,onOpen:(id?:string|null)=>void) {
 const callback=useRef(onOpen);callback.current=onOpen;
 useEffect(()=>{
  const openHash=()=>{
   if(!authorizedSession)return;
   const match=/^#people-chats(?:\/([a-zA-Z0-9_-]{1,128}))?$/.exec(window.location.hash);
   if(!match)return;
   // Invitation links carry a one-time return target; app navigation stays in state.
   window.history.replaceState(window.history.state,'',`${window.location.pathname}${window.location.search}`);
   callback.current(match[1]||null);
  };
  const openEvent=(event:Event)=>{const id=(event as CustomEvent<{conversationId?:unknown}>).detail?.conversationId;if(authorizedSession&&typeof id==='string'&&/^[a-zA-Z0-9_-]{1,128}$/.test(id))callback.current(id);};
  openHash();window.addEventListener('hashchange',openHash);window.addEventListener('contact-chat:open',openEvent);
  return()=>{window.removeEventListener('hashchange',openHash);window.removeEventListener('contact-chat:open',openEvent);};
 },[authorizedSession]);
}
